import type { Silo, SiloId } from '../../types/blog';

export const SILOS: Record<SiloId, Silo> = {
  performance: {
    id: 'performance',
    title: 'Performance PC',
    description: 'PC lent, démarrage lent, surchauffe, disque saturé',
    color: 'bg-orange-500',
    icon: 'Zap',
  },
  securite: {
    id: 'securite',
    title: 'Virus & Sécurité',
    description: 'Virus, malwares, pop-ups, erreurs Windows',
    color: 'bg-red-600',
    icon: 'Shield',
  },
  reseau: {
    id: 'reseau',
    title: 'Réseau & Internet',
    description: 'Internet lent, WiFi, box, DNS',
    color: 'bg-sky-600',
    icon: 'Wifi',
  },
  windows: {
    id: 'windows',
    title: 'Windows & Système',
    description: 'BSOD, démarrage, mises à jour, mot de passe',
    color: 'bg-blue-600',
    icon: 'Monitor',
  },
  materiel: {
    id: 'materiel',
    title: 'Matériel & Périphériques',
    description: 'Imprimante, webcam, son, logiciels',
    color: 'bg-purple-600',
    icon: 'Printer',
  },
  recuperation: {
    id: 'recuperation',
    title: 'Récupération & Emails',
    description: 'Fichiers supprimés, Outlook, Gmail',
    color: 'bg-emerald-600',
    icon: 'HardDriveDownload',
  },
  telephone: {
    id: 'telephone',
    title: 'Réparation téléphone & tablette',
    description: "Écran cassé, batterie, ne s'allume plus, ne charge plus",
    color: 'bg-teal-600',
    icon: 'Smartphone',
  },
  'site-internet': {
    id: 'site-internet',
    title: 'Site internet & visibilité',
    description: 'Création de site, référencement, visibilité locale pour indépendants et TPE',
    color: 'bg-indigo-600',
    icon: 'Globe',
  },
};
